var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "entries-list-item" }, [
    _c("div", { staticClass: "edit-container" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.entry.value,
            expression: "entry.value",
          },
        ],
        staticClass: "title-input",
        attrs: { placeholder: _vm.$t("chatbotv2.title") },
        domProps: { value: _vm.entry.value },
        on: {
          focus: _vm.inputOnClickHandler,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.entry, "value", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "content-input-wrapper" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.synonymsVmodel,
              expression: "synonymsVmodel",
            },
          ],
          staticClass: "content-input",
          attrs: { placeholder: _vm.$t("chatbotv2.synonyms"), autofocus: true },
          domProps: { value: _vm.synonymsVmodel },
          on: {
            focus: _vm.inputOnClickHandler,
            blur: _vm.synonymInputBlurHandler,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.addSynonym.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.synonymsVmodel = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm.open
          ? _c(
              "div",
              { staticClass: "synonyms" },
              _vm._l(_vm.entry.synonyms, function (item) {
                return _c(
                  "a-tag",
                  {
                    key: item.value,
                    staticClass: "synonym-tag",
                    attrs: { closable: "" },
                    on: {
                      close: function ($event) {
                        return _vm.deleteSynonym(item.value)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.value) + "\n                ")]
                )
              }),
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.open
        ? _c("div", { staticClass: "actions" }, [
            _c(
              "div",
              {
                staticClass: "icon-container",
                on: { click: _vm.cancelOnClickHandler },
              },
              [_c("md-icon", { staticClass: "close-icon" }, [_vm._v("close")])],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "icon-container", on: { click: _vm.updateEntry } },
              [_c("md-icon", { staticClass: "apply-icon" }, [_vm._v("done")])],
              1
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "delete-entry",
        style: _vm.open && { display: "none" },
        on: { click: _vm.deleteEntry },
      },
      [_c("md-icon", [_vm._v("delete")])],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }